"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openAiChatCompletion = void 0;
const openAiChatCompletion = ({ messages, controller, }) => {
    const apiKey = localStorage.getItem("OPENAI_API_KEY") || "";
    const responsePromise = (() => __awaiter(void 0, void 0, void 0, function* () {
        return fetch("https://api.openai.com/v1/chat/completions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${apiKey}`,
            },
            body: JSON.stringify({
                model: "gpt-35-turbo",
                temperature: 0.0,
                stream: true,
                messages,
            }),
            signal: controller === null || controller === void 0 ? void 0 : controller.signal,
        });
    }))();
    return responsePromise;
};
exports.openAiChatCompletion = openAiChatCompletion;
